import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  filterAccordion: {
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    position: 'relative',
    '&::before': {
      display: 'none',
    },
  },
  filterAccordionIcon: {
    height: 'auto',
    width: 24,
    fill: theme.palette.common.black,
  },
  filterAccordionSummary: {
    margin: theme.spacing(0, 0),
    fontSize: 16,
    fontFamily: theme.gh_vars.circular,
    lineHeight: 1.75
  },
  filterAccordionDetails: {
    display: 'block',
    marginBottom: theme.spacing(2)
  },
  count: {
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontSize: '14px !important',
    lineHeight: 1,
    color: theme.palette.common.white,
    background: '#A3403D',
  },
  filtersContainer: {
    border: '1px solid',
    borderLeft: '0px solid',
    borderColor: '#DDDDDD',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#f7f7f7',
    transform: 'translateY(100%)',
    transition: 'transform .2s',
    padding: theme.spacing(2),
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      transform: 'translateY(0px)',
      maxWidth: 350,
      width: '100%',
      height: 'calc(100vh - 64px)',
      overflowY: 'auto',
    }
  },
  filtersContainerOpen: {
    transform: 'translateY(0px)',
  },
  filtersContainerInner: {
    flex: 1,
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(10)
    }
  },
  filtersContainerHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  filterContainerButtons: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    textAlign: 'center',
    padding: theme.spacing(1, 2, 2),
    position: 'fixed',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1300
  },
}));
